import {Component} from "@angular/core";

@Component({
    selector: "fui-attributed-list-entry-attributes",
    styleUrls: ["./attributed-list-entry-attributes.component.scss"],
    templateUrl: "./attributed-list-entry-attributes.component.html"
})
export class FUIAttributedListEntryAttributesComponent {
}
